'use client'
import { useEffect } from 'react'

const intentEvents = ['pointerover', 'pointerdown', 'focusin'] as const

/**
 * Prepares menu content when the visitor points at, touches or focuses the
 * nav. An idle callback can run before the first paint, so loading optional
 * content there still competes with the article's initial resources.
 * `load` must have a stable identity; the module system caches its import.
 */
export const useIntentPreload = (enabled: boolean, load: () => Promise<unknown>) => {
  useEffect(() => {
    if (!enabled) {
      return undefined
    }
    let started = false
    const run = () => {
      if (started) {
        return
      }
      started = true
      void load().catch(() => {
        // A later interaction may retry a failed speculative request.
        started = false
      })
    }
    const onIntent = (event: Event) => {
      if (event.target instanceof Element && event.target.closest('[data-nav-bar]')) {
        run()
      }
    }
    intentEvents.forEach((event) => document.addEventListener(event, onIntent))
    return () => {
      intentEvents.forEach((event) => document.removeEventListener(event, onIntent))
    }
  }, [enabled, load])
}
